type Props = {
  speaker: string;
  onClick: (speaker: string) => void;
};
export const SpeakerBlock = ({ speaker, onClick }: Props) => {
  return (
    <div className="border border-[#E5E5E5] flex w-full cursor-pointer" onClick={() => onClick(speaker)}>
      <div className="h-16 shrink-0" />
      <div className="px-5 flex flex-col text-primary justify-evenly">
        <p className="text-sm leading-4">Avec</p>
        <p className="text-base leading-4 font-bold">{speaker}</p>
      </div>
    </div>
  );
};
